<template>
  <base-form :title="title" @submit="submit">
    <fg-input :name="$t('settings.segments.create.name.label')"
              required
              :label="$t('settings.segments.create.name.label')"
              :placeholder="$t('settings.segments.create.name.placeholder')"
              v-model="model.name"
              v-validate="validations.name"
              :error="getError($t('settings.segments.create.name.label'))">
    </fg-input>
    <fg-input :placeholder="$t('settings.segments.create.validationMin.placeholder')"
              :label="$t('settings.segments.create.validationMin.label')"
              :name="$t('settings.segments.create.validationMin.label')"
              type="number"
              v-model="model.validation_min">
    </fg-input>
    <fg-input :placeholder="$t('settings.segments.create.validationMax.placeholder')"
              :label="$t('settings.segments.create.validationMax.label')"
              :name="$t('settings.segments.create.validationMax.label')"
              type="number"
              v-model="model.validation_max">
    </fg-input>

    <dl class="rounded overflow-hidden mt-6 mb-4">
      <div class="list-row bg-gray-50">
        <dt class="list-row-dt">
          {{$t(`generic.jobs`)}}
        </dt>
        <dd class="list-row-dd">
          <base-switch v-model="model.jobs">
          </base-switch>
        </dd>
      </div>
      <div class="list-row bg-white">
        <dt class="list-row-dt">
          {{$t(`generic.organisations`)}}
        </dt>
        <dd class="list-row-dd">
          <base-switch v-model="model.organisations">
          </base-switch>
        </dd>
      </div>
      <div class="list-row bg-gray-50">
        <dt class="list-row-dt">
          {{$t(`generic.candidates`)}}
        </dt>
        <dd class="list-row-dd">
          <base-switch v-model="model.candidates">
          </base-switch>
        </dd>
      </div>
    </dl>
  </base-form>
</template>
<script>
  export default {
    props: {
      segment: {
        type: Object,
        default: () => ({})
      },
      title: String
    },
    data () {
      return {
        model: {
          name: '',
          active_always: true,
          validation_min: 0,
          validation_max: 0,
          jobs: true,
          organisations: true,
          candidates: true
        },
        validations: {
          name: {
            required: true,
            max: 100
          },
          validation_min: {
            min_value: 0
          },
          validation_max: {
            min_value: 0
          }
        }
      }
    },
    methods: {
      async submit () {
        let res = await this.$validator.validateAll()
        if (res) {
          this.$emit('submit', this.model)
        }
      },
    },
    created () {
      this.$watch('segment', newVal => {
        this.model = {
          ...newVal
        }
        if (!this.model.active_always) {
          this.model.active_always = true
        }
      }, {immediate: true})
    }
  }
</script>
<style lang="scss">
</style>
